import React, { useState, useEffect } from "react";
import DeliveryHead from "../delivery/DeliveryHead";
import { Container, Grid, Tooltip } from "@mui/material";
import dollericon from "../../../assets/images/dollericon.png";
import recordcircle from "../../../assets/images/record-circle.png";
import location from "../../../assets/images/location.png";
import GoogleMap from "../../shared/map";
import {
  MapMain,
  PriceSec,
  MoreDetails,
} from "./styles/TransactionDetailsStyle";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { TRANSACTIOS } from "../../../constants/apiEndPoints";
import Loader from "../../shared/loader";
import httpRequest from "../../../axios/index";
import { getTwoDecimalPlaces } from "../../../helpers/PriceDigest";
import { AddressSpan } from "../orders/styles/OrderResultStyle";
import { formatDateTime } from "../../../helpers/DateFormate";

const TransactionDetails = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [Loading, setLoading] = useState(false);
  const [TransactionsData, SetTransactionsData] = useState([]);

  const [PickUpLocation, SetPickUpLocation] = useState([]);

  const [DropoffLocation, SetDropoffLocation] = useState([]);

  useEffect(() => {
    GetAllOrders();
  }, [id]);

  const GetAllOrders = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(`${TRANSACTIOS}/${id}`);
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          SetTransactionsData(resp?.data?.data);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };
  // console.log("TransactionsData", TransactionsData);

  useEffect(() => {
    if (
      TransactionsData &&
      TransactionsData?.order?.stops &&
      TransactionsData?.order?.stops?.length > 0
    ) {
      SetPickUpLocation({
        lat: TransactionsData?.order?.stops[0]?.location?.latitude,
        lng: TransactionsData?.order?.stops[0]?.location?.longitude,
      });
      SetDropoffLocation({
        lat: TransactionsData?.order?.stops[1]?.location?.latitude,
        lng: TransactionsData?.order?.stops[1]?.location?.longitude,
      });
    }
  }, [TransactionsData]);

  return (
    <>
      {Loading && <Loader />}

      {!Loading && TransactionsData && (
        <>
          <DeliveryHead
            Value={66}
            BackLink="/transaction"
            CenterText="Transaction Details"
            StepText="2 of 3"
            showBox={false}
            showLink={true}
          />
          <Container maxWidth="lg">
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={8} lg={6}>
                <MapMain>
                  {TransactionsData &&
                    TransactionsData?.order?.stops &&
                    TransactionsData?.order?.stops?.length > 0 && (
                      <>
                        <GoogleMap
                          LocationIcon={false}
                          hasRoutes={true}
                          PichUpLocation={PickUpLocation}
                          DropoffLocation={DropoffLocation}
                        />
                      </>
                    )}
                </MapMain>
                <PriceSec>
                  <div className="price_sec">
                    <img src={dollericon} alt="dollericon" />
                    <span>
                      {/* ${getTwoDecimalPlaces(TransactionsData?.amount)} */}$
                      {TransactionsData?.amount}
                    </span>
                  </div>
                  {/* <div className="time_sec">
                <h6>ETA:</h6>
                <span>20 Minutes</span>
              </div> */}
                  <div className="time_sec">
                    {/* <h6>ETA:</h6> */}
                    <span>{formatDateTime(TransactionsData?.created_at)}</span>
                  </div>
                </PriceSec>
                {/*  */}

                {TransactionsData &&
                  TransactionsData?.order?.stops &&
                  TransactionsData?.order?.stops?.length > 0 && (
                    <>
                      <MoreDetails>
                        <div className="pickup_ItemMain">
                          <img src={recordcircle} alt="Clothesbox" />
                          <Tooltip
                            title={
                              TransactionsData?.order?.stops[0]?.location
                                ?.address
                            }
                            arrow
                          >
                            <AddressSpan>
                              {
                                TransactionsData?.order?.stops[0]?.location
                                  ?.address
                              }
                            </AddressSpan>
                          </Tooltip>
                        </div>
                        <div className="drop_ItemMain">
                          <img src={location} alt="Clothesbox" />
                          <Tooltip
                            title={
                              TransactionsData?.order?.stops[1]?.location
                                ?.address
                            }
                            arrow
                          >
                            <AddressSpan>
                              {
                                TransactionsData?.order?.stops[1]?.location
                                  ?.address
                              }
                            </AddressSpan>
                          </Tooltip>
                        </div>
                      </MoreDetails>
                    </>
                  )}

                {/*  */}
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </>
  );
};

export default TransactionDetails;
